import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Stack, TextField, Typography, Alert } from '@mui/material';
import { Lock } from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../store';
import { updateUser } from '../store/authSlice';
import api from '../services/api';

/**
 * Overlay que se muestra recién después del onboarding para que el usuario
 * defina su contraseña. Bloqueante suave: no se puede cerrar sin definirla.
 */
export const SetPasswordOverlay: React.FC = () => {
  const dispatch = useDispatch();
  const user = useSelector((s: RootState) => s.auth.user);
  const [pwd, setPwd] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  if (!user?.mustSetPassword) return null;

  const submit = async () => {
    setError(null);
    if (pwd.trim().length < 6) { setError('La contraseña debe tener al menos 6 caracteres.'); return; }
    if (pwd !== confirm) { setError('Las contraseñas no coinciden.'); return; }
    setBusy(true);
    try {
      await api.setMyPassword(pwd.trim());
      dispatch(updateUser({ mustSetPassword: false }));
    } catch (e: any) {
      setError(e?.response?.data?.message || 'No se pudo guardar la contraseña.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open maxWidth="xs" fullWidth disableEscapeKeyDown
      PaperProps={{ sx: { borderRadius: 3 } }}>
      <DialogTitle>
        <Stack direction="row" spacing={1} alignItems="center"><Lock color="primary" /><span>Definí tu contraseña</span></Stack>
      </DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 1 }}>
          <Typography variant="body2" color="text.secondary">
            ¡Listo el onboarding! Para proteger tu cuenta, elegí una contraseña.
          </Typography>
          {error && <Alert severity="error">{error}</Alert>}
          <TextField type="password" label="Contraseña" autoFocus value={pwd}
            onChange={e => setPwd(e.target.value)} onKeyDown={e => e.key === 'Enter' && submit()} />
          <TextField type="password" label="Repetir contraseña" value={confirm}
            onChange={e => setConfirm(e.target.value)} onKeyDown={e => e.key === 'Enter' && submit()} />
        </Stack>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button variant="contained" fullWidth disabled={busy} onClick={submit}>
          {busy ? 'Guardando…' : 'Guardar contraseña'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SetPasswordOverlay;
